import { gql } from "@apollo/client"
// Fragments

const COMPANY_FRAGMENTS = {
  companyDetail: gql`
    fragment CompanyDetailFrag on CompanyType {
      id
      name
      codename
      displayName
      departments {
        id
        name
      }
    }
  `,
}

const COMPANY_LIST = gql`
  query allCompaniesList($id: Int) {
    allCompanies(departmentId: $id) {
      id
      name
      codename
      kind
      displayName
      departments {
        id
        name
      }
    }
  }
`

export const COMPANY_DETAILS = gql`
  query companyDetail($id: Int) {
    companyDetails(companyId: $id) {
      ...CompanyDetailFrag
    }
  }
  ${COMPANY_FRAGMENTS.companyDetail}
`

const ADD_UPDATE_COMPANY = gql`
  mutation addUpdateCompany(
    $id: Int
    $name: String
    $codename: String
    $displayName: String
    $departments: [Int]
  ) {
    addCompany(
      id: $id
      name: $name
      codename: $codename
      displayName: $displayName
      departments: $departments
    ) {
      company {
        ...CompanyDetailFrag
      }
    }
  }
  ${COMPANY_FRAGMENTS.companyDetail}
`

export { ADD_UPDATE_COMPANY, COMPANY_LIST, COMPANY_FRAGMENTS }
